module.exports = __webpack_public_path__ + "static/media/bo-ov.937a0b5f.png";